import script from "./vue-select-nativo.vue?vue&type=script&setup=true&lang=js"
export * from "./vue-select-nativo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__